import { render } from "./ProfessionalForm.vue?vue&type=template&id=55555192"
import script from "./ProfessionalForm.vue?vue&type=script&lang=ts"
export * from "./ProfessionalForm.vue?vue&type=script&lang=ts"
script.render = render

export default script